import { apiV1Endpoint } from "../../../../../api/v1";
import axios from "../../../../../utils/axiosInceptor";

export type ReassignRequest = {
  ticketId: string;
  landlordId: string;
};

export const reassignServiceRequest = async (body: ReassignRequest) => {
  const url = `${apiV1Endpoint}/general-services/service-requests/re-assign`;
  const response = await axios.post(url, body);
  return response.data;
};
